import { Box, ColorOptions, IconButton, Image, LoaderNew, ModBox, Spacer, SpacerNew, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../../components/AdminInputs'
import { ButtonNew } from '../../../components/AdminButton'
import { useIsFocused, useNavigation } from '@react-navigation/core'
import { useCallback, useEffect, useState } from 'react'
import { Animated, Easing, ScrollView, useWindowDimensions } from 'react-native'
import { EmType } from '..'
import ActionsMenu from '../../../components/ActionMenu/ActionsMenu'
import { Dropdown } from '../../../components/Dropdown'
import { Filters } from '../../../components/FiltersWeb'
import { filterTypes } from '../../../components/FiltersWeb/types'
import { StatusIndicator } from '../../../components/StatusIndicator'
import { useLazyApiData, useStores } from '../../../data/store'
import { isAccessible } from '../../../utils'
import { checkDropdownData } from '../../../utils/constants'
import { AuditTrail } from '../../AuditTrial'
import CheckerStatus from '../../Checker/Status'
import { BusinessDetails } from '../Onboarding/BusinessDetails'
import { ContactProfiles } from '../Onboarding/ContactProfiles'
import { SelectParentEntityList } from '../Onboarding/CreateEntity/SelectParentEntityList'
import { Documentation } from '../Onboarding/Documentation'
import { Settings } from '../Onboarding/Settings'
import { SettlementDetails } from '../Onboarding/SettlementDetails'
import { styles } from '../styles'
import { AccountSummary } from './AccountSummary'
import { EmsDevices } from './Devices'
import { EntityHierarchy } from './EntityHierarchy'
import { Menu } from './Menu'
import { TIDList } from './TIDList'

const levelFilterData = {
  data: ['ALL', 'L1', 'L2', 'L3', 'L4', 'L5'],
  title: 'Level',
  mode: 'level',
}

const statusFilterData = {
  data: ['ALL', 'Active', 'Hold', 'Terminated', 'Suspended'],
  title: 'Status',
  mode: 'status',
}

const searchColumnSize: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
}
const searchHeaderTitle = [
  { title: 'Entity ID' },
  { title: 'Parent Id' },
  { title: 'Business Name' },
  { title: 'Level' },
  { title: 'Mobile Number' },
  { title: 'Status' },
]
// const statusDropdownData = [
//   { id: '1', value: 'Active' },
//   { id: '2', value: 'Inactive' },
//   { id: '3', value: 'Inprogress' },
//   { id: '4', value: 'Deleted' },
// ]

interface SearchEntityProps {
  route: any
}

const Footer = ({ show, onSubmit, applicationStatus = '', checkerComments = '' }: any) => {
  const [status, setStatus] = useState('')
  const [comments, setComments] = useState('')
  const isFocus = useIsFocused()

  const onDropDownChange = (selected: string) => {
    setStatus(selected)
  }

  const onHandleSubmit = () => {
    onSubmit && onSubmit(status, comments)
  }

  useEffect(() => {
    if (isFocus && (status !== '' || comments !== '')) {
      setComments('')
      setStatus('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!show) {
    return null
  }
  return (
    <ScrollView>
      <Box {...styles.footer}>
        <Box w={'100%'} alignItems={'center'} justifyContent={'space-between'} direction="row">
          <Box direction="row">
            <ModBox h={52} show={applicationStatus !== 'Rejected'}>
              <Text title={'Status'} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_75'} />
              <Spacer direction="vertical" size={8} />
              <Box borderWidth={1} borderColor={'BORDER_COLOR'} borderRadius={4}>
                <Dropdown
                  minHeight={32}
                  minWidth={150}
                  testID="selectStatus"
                  title={'Select Status'}
                  selectedData={onDropDownChange}
                  data={checkDropdownData}
                  value={status}
                  transparentBorder={true}
                />
              </Box>
            </ModBox>
            <Box marginLeft={16} width={367}>
              <Text title={"Checker's Comments"} fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_75'} />
              <Spacer direction="vertical" size={8} />
              <Box
                borderWidth={applicationStatus === 'Rejected' ? 0 : 1}
                borderColor={'BORDER_COLOR'}
                borderRadius={4}
                overflow={'auto'}
                nativeID={applicationStatus !== 'Rejected' ? 'vertical-scroll' : undefined}
                height={72}>
                <TextInputNew
                  placeholder={'Write your comments here (max 4096 characters)...'}
                  value={applicationStatus === 'Rejected' ? checkerComments : comments}
                  onChangeText={setComments}
                  focusBorderColor={'TRANSPARENT'}
                  labelFontFamily={'jiotype-medium'}
                  fontSize={12}
                  paddingHorizontal={8}
                  paddingVertical={8}
                  numberOfLines={4}
                  multiline
                  maxLength={4096}
                  placeholderTextColor={'DARK_GREY'}
                  editable={applicationStatus !== 'Rejected'}
                  color={'BLACK_21'}
                />
              </Box>
            </Box>
          </Box>
          <ButtonNew
            onPress={onHandleSubmit}
            title={'Submit'}
            height={40}
            width={94}
            hide={applicationStatus === 'Rejected'}
            color={comments?.length === 0 || status?.length === 0 ? '#B9D3E7' : 'PRIMARY'}
            disabled={comments?.length === 0 || status?.length === 0}
          />
        </Box>
      </Box>
    </ScrollView>
  )
}

const Header = ({
  show,
  rotateValue,
  isSyncing,
  selectedEntity,
  getSyncWithMasData,
  fetchSyncWithMas,
  setIsSyncing,
  from,
  searchData,
  navigation,
  setShowSearchResults,
  searchItemPressed,
  searchFilterBy,
  group,
  data,
  showSearchResults,
  isMasEntity,
  headerData,
  getKeyTitle,
  lastSyncedDate,
  status,
  showApproveReject,
  setSideMenuRefresh,
  accessConfig,
  getLovsDescriptionFromKeyValue,
  subgroup,
}: any) => {
  const startImageRotation = () => {
    rotateValue.setValue(0)
    Animated.loop(
      Animated.timing(rotateValue, {
        toValue: 1,
        duration: 3000,
        easing: Easing.linear,
        useNativeDriver: true,
      }),
      {
        iterations: 15,
      },
    ).start()
  }

  const rotateData = rotateValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg'],
  })

  const onSyncPressed = () => {
    if (!isSyncing) {
      const data = getSyncWithMasData(selectedEntity?.id)
      fetchSyncWithMas(data)
      setIsSyncing(true)
      startImageRotation()
    }
  }
  const handleBack = () => {
    if (from === 'search' || from === undefined) {
      const data = searchData(EmType.Search)
      if (data?.length === 1) {
        navigation.reset({
          index: 0,
          routes: [{ name: 'home' }],
        })
      } else {
        setShowSearchResults(true)
      }
      setSideMenuRefresh(true)
    } else {
      if (from === 'MAKER_QUEUE') {
        navigation.navigate('makerMyQueue')
        setSideMenuRefresh(true)
      } else if (from === 'CHECKER_MYQUEUE') {
        navigation.navigate('checkerMyQueue')
        setSideMenuRefresh(true)
      } else if (from === 'CHECKER_QUEUE') {
        navigation.navigate('checkerGlobalQueue')
        setSideMenuRefresh(true)
      } else if (from === 'CREATE_ENTITY') {
        navigation.navigate('createSingleEntity')
        setSideMenuRefresh(true)
      } else {
        navigation.goBack()
        setSideMenuRefresh(true)
      }
    }
  }

  const syncingImg = require('../../../assets/images/syncing.svg')
  const syncedImg = require('../../../assets/images/synced.svg')
  return (
    <ModBox show={show} borderBottomWidth={1} borderBottomColor={'BORDER_COLOR'}>
      <Box p={16}>
        <ModBox direction="row" justifyContent={'space-between'}>
          <ModBox direction="row" h={24}>
            <ModBox show={searchItemPressed && searchFilterBy !== 'Group ID' && searchFilterBy !== 'SubGroup ID'}>
              <IconButton id="ARROW_BACK" size={24} color={'#0070B6' as ColorOptions} onPress={handleBack} />
            </ModBox>
            <Spacer size={16} direction={'horizontal'} />
            <Text
              title={
                searchFilterBy === 'Group ID'
                  ? group?.brandName
                  : searchFilterBy === 'SubGroup ID'
                  ? subgroup?.[0]?.brandName
                  : from === 'MAKER_QUEUE' || from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE'
                  ? data?.businessName
                  : selectedEntity?.businessName
              }
              color={'BLACK_21'}
              fontSize={18}
              fontFamily={'jiotype-bold'}
            />
            <Spacer size={16} direction={'horizontal'} />
            <ModBox show={searchItemPressed}>
              <StatusIndicator
                type={
                  from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
                    ? data?.applicationStatus?.toLowerCase()
                    : status?.length > 0
                    ? getLovsDescriptionFromKeyValue('Status', status)?.toString()?.toLowerCase()
                    : 'NA'
                }
              />
            </ModBox>
          </ModBox>
          <ModBox
            width={150}
            show={!showSearchResults && isMasEntity && isAccessible(accessConfig, 'create') && false}
            height={32}
            flexDirection={'row'}
            backgroundColor={isSyncing ? ('#E9D8B8' as ColorOptions) : 'WHITE'}
            borderRadius={4}
            borderWidth={isSyncing ? undefined : 1}
            borderColor={isSyncing ? undefined : 'PRIMARY'}
            onPress={onSyncPressed}
            alignItems={'center'}
            justifyContent={'center'}
            underlayColor={'LIGHTEST_GREY'}>
            <Animated.View
              // eslint-disable-next-line react-native/no-inline-styles
              style={{
                width: 16,
                height: 16,
                marginRight: 8,
                transform: [{ rotate: rotateData }],
              }}>
              <Image width={16} height={16} source={isSyncing ? syncingImg : syncedImg} />
            </Animated.View>
            <SpacerNew size={16} direction={'vertical'} />
            <Text
              fontSize={12}
              fontFamily={'jiotype-medium'}
              title={isSyncing ? 'Syncing...' : 'Sync with MAS'}
              color={isSyncing ? ('#B87200' as ColorOptions) : 'PRIMARY'}
            />
          </ModBox>
        </ModBox>
        <ModBox
          w={'100%'}
          show={searchItemPressed}
          direction="row"
          marginLeft={searchFilterBy !== 'Group ID' && searchFilterBy !== 'SubGroup ID' ? 48 : 16}
          marginRight={16}
          justifyContent={'space-between'}
          marginTop={8}>
          <ModBox direction="row" flexWrap={'wrap'} w={'100%'}>
            {Object.keys(headerData).map((key, index) => {
              if (key === 'status') {
                return null
              }
              return (
                <Box
                  key={index}
                  backgroundColor={'#F0F0F0' as ColorOptions}
                  borderRadius={2}
                  padding={4}
                  direction={'row'}
                  marginRight={24}>
                  <Text
                    title={getKeyTitle(
                      key,
                      searchFilterBy,
                      from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
                        ? data?.applicationStatus?.toLowerCase()
                        : status,
                    )}
                    color={'BLACK_75'}
                    fontSize={12}
                    fontFamily={'jiotype-medium'}
                  />
                  <Text
                    title={
                      `${headerData?.[key]}`?.length > 0
                        ? key === 'level'
                          ? `L${headerData?.[key]}`
                          : headerData?.[key]
                        : 'NA'
                    }
                    color={'BLACK_21'}
                    fontSize={12}
                    fontFamily={'jiotype-bold'}
                  />
                </Box>
              )
            })}
          </ModBox>
          <ModBox marginTop={12} show={false}>
            <Text
              title={`Last synced : ${lastSyncedDate}`}
              color={'BLACK_75'}
              fontSize={10}
              fontStyle={'italic'}
              fontFamily={'jiotype-medium'}
            />
          </ModBox>
        </ModBox>
      </Box>
    </ModBox>
  )
}

const SearchEntity = ({ route }: SearchEntityProps) => {
  const { data, from, isApprovedByChecker, showApproveReject = false } = route?.params ?? {}
  const {
    globalSearchString,
    searchData,
    syncWithMas,
    // updatePagination,
    // paginationData,
    // resetPagination,
    selectedFilteredData,
    updateFilters,
    checkSelected,
    searchDataWithFilters,
    isEntityPresentInMas,
    getSyncWithMasData,
    updateContactProfilesFromSearch,
    searchApiStatus,
    getSearchHeaderData,
    approveRejectTask,
    getBusinessDetailsFromTaskId,
    fetchSearchEntity,
    searchFilterBy,
    group,
    updateContactOfGroupSubGroup,
    isSyncDone,
    setSideMenuRefresh,
    accessConfig,
    getLovsDescriptionFromKeyValue,
    fetchAllLovs,
    subgroup,
    getOnboardingChannel,
  } = useStores((store) => ({
    globalSearchString: store.onboarding.globalSearchString,
    searchData: store.getSearchData,
    syncWithMas: store.syncWithMas,
    // updatePagination: store?.updatePagination,
    // paginationData: store?.pagination,
    // resetPagination: store?.resetPagination,
    selectedFilteredData: store.filter.getFilterData,
    updateFilters: store.filter.updateFilters,
    checkSelected: store.filter.checkSelected,
    searchDataWithFilters: store.searchDataWithFilters,
    isEntityPresentInMas: store.onboarding.isEntityPresentInMas,
    getSyncWithMasData: store.getSyncWithMasData,
    updateContactProfilesFromSearch: store.updateContactProfilesFromSearch,
    searchApiStatus: store.onboarding.searchApiStatus,
    getSearchHeaderData: store.getSearchHeaderData,
    approveRejectTask: store.approveRejectTask,
    getBusinessDetailsFromTaskId: store.getBusinessDetailsFromTaskId,
    fetchSearchEntity: store.fetchSearchEntity,
    searchFilterBy: store.onboarding.searchFilterBy,
    group: store.onboarding.group,
    updateContactOfGroupSubGroup: store.updateContactOfGroupSubGroup,
    isSyncDone: store.onboarding.isSyncDone,
    setSideMenuRefresh: store.setSideMenuRefresh,
    accessConfig: store.user.getAccessConfig(['entity_management_service', 'single_entity']),
    getLovsDescriptionFromKeyValue: store.getLovsDescriptionFromKeyValue,
    fetchAllLovs: store.fetchAllLovs,
    subgroup: store.onboarding.subgroup,
    getOnboardingChannel: store.getOnboardingChannel,
  }))

  const [selectedEntity, setSelectedEntity] = useState(data !== undefined ? data : '')

  const [fetchSyncWithMas, fetchSyncWithMasHandler] = useLazyApiData(syncWithMas)
  const [fetchApproveRejectTask, fetchApproveRejectTaskHandler] = useLazyApiData(approveRejectTask)
  const [getAllLovs, getSingleLovHandler] = useLazyApiData(fetchAllLovs)

  const [searchApi, searchHandler] = useLazyApiData(fetchSearchEntity)

  const navigation = useNavigation()
  const [status, setStatus] = useState(
    from && (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE') ? data?.status : '',
  )

  const getSelectedScreenId = () => {
    if (searchFilterBy === 'Group ID' || searchFilterBy === 'SubGroup ID') {
      return 6
    } else if (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE') {
      if (selectedEntity && (selectedEntity?.requestType === 'SUBGROUP' || selectedEntity?.requestType === 'GROUP')) {
        return 6
      } else if (selectedEntity?.requestType === 'MERCHANT') {
        return 1
      }
    }
    return 1
  }
  const [selectedScreenId, setSelectedScreenId] = useState(getSelectedScreenId())
  console.log('getSelectedScreenId', getSelectedScreenId(), selectedScreenId)

  console.log('===> selectedScreenId: ', selectedScreenId)
  const [searchResultsCount, setSearchResultsCount] = useState(0)
  const [showSearchResults, setShowSearchResults] = useState(
    from && (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE') ? false : true,
  )
  const [searchItemPressed, setSearchItemPressed] = useState(
    from && (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE')
      ? true
      : data !== undefined,
  )
  const [searchListData, setSearchListData] = useState([])
  const [lastSyncedDate, setLastSyncedDate] = useState('') //TODO: set from API response fullfiled
  const [isSyncing, setIsSyncing] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false)
  const [filterApplied, setFilterApplied] = useState(false)
  const [rotateValue, setRotateValue] = useState(new Animated.Value(0))
  const [isSubMenuExpanded, setIsSubMenuExpanded] = useState(false)
  const [showSearchScreen, setShowSearchScreen] = useState(true)
  const [isCheckerApproved, setCheckerApproved] = useState(
    from && (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE')
      ? isApprovedByChecker
      : false,
  )
  const [approveRejectData, setApproveRejectData] = useState(
    from && (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE')
      ? { apiResponse: {}, data: data }
      : { apiResponse: {}, data: {} },
  )
  const [showCheckerStatus, setShowCheckerStatus] = useState(
    from && (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE')
      ? isApprovedByChecker
      : false,
  )

  const [previousFilterBy, setPreviousFilterBy] = useState('')

  const isFocused = useIsFocused()
  useEffect(() => {
    setSelectedEntity(data)
    setSelectedScreenId(getSelectedScreenId())
    setCheckerApproved(
      from && (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE')
        ? isApprovedByChecker
        : false,
    )
    if (isFocused) {
      const masKeysArray1 = [
        'Status',
        'SUPPORTED_PROCESSING_ENTITY',
        'SetupCompleteInd',
        'Country',
        'SettlementAccountType',
      ]
      getAllLovs(...masKeysArray1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, isSyncDone])

  const [isLoading, setIsLoading] = useState(false)
  const [headerData, setHeaderData] = useState({
    id: data?.applicationId ?? '',
    masId: data?.masId ?? '',
    onboardingChannel: getOnboardingChannel(selectedEntity?.id),
    type: data?.type ?? '',
    level: data?.level ?? '',
    group: data?.group?.legalName,
    subGroup: data?.subGroup?.legalName,
  })

  const isMasEntity = isEntityPresentInMas(selectedEntity?.id)

  useEffect(() => {
    if (fetchApproveRejectTaskHandler?.state === 'fulfilled') {
      if (!showCheckerStatus) {
        setShowCheckerStatus(true)
        setApproveRejectData({ apiResponse: fetchApproveRejectTaskHandler?.data, data: data })
      }
    } else if (fetchApproveRejectTaskHandler?.state === 'rejected') {
      //TODO: handle rejected or failed case
    }
  }, [data, fetchApproveRejectTaskHandler?.data, fetchApproveRejectTaskHandler?.state, showCheckerStatus])

  useEffect(() => {
    if (selectedEntity?.id) {
      const mData = getSearchHeaderData(selectedEntity?.id)
      console.log('SearchEntity data', mData)
      setHeaderData(mData)
      setSelectedScreenId(1)
      setStatus(mData?.status)
    }
  }, [getSearchHeaderData, selectedEntity, isSyncDone])

  useEffect(() => {
    if (data && data?.applicationId) {
      setHeaderData({
        id: data?.identificationNumber?.length > 0 ? data?.identificationNumber : data?.applicationId ?? '',
        masId: data?.parentEntityIdentificationNumber ?? '',
        onboardingChannel: getOnboardingChannel(data?.identificationNumber),
        type: data?.type ?? '',
        level: data?.level ?? '',
        group: data?.group?.legalName,
        subGroup: data?.subGroup?.legalName,
      })
      setSelectedEntity(data)
    }
  }, [data, data?.applicationId])

  const onSearchRowPress = useCallback(
    (data: any) => {
      console.log('SearchEntity onSearchRowPress data', data)
      setShowSearchResults(false)
      setSearchItemPressed(true)
      setSelectedEntity(data)
      setHeaderData(
        searchFilterBy === 'Group ID'
          ? {
              id: data?.identificationNumber,
              onboardingChannel: '',
              type: 'Group',
              masId: '',
              level: '',
              group: '',
              subGroup: '',
            }
          : searchFilterBy === 'SubGroup ID'
          ? {
              id: data?.[0]?.identificationNumber,
              onboardingChannel: '',
              type: 'SubGroup',
              masId: data?.[0]?.group?.identificationNumber,
              level: '',
              group: data?.[0]?.group?.brandName,
              subGroup: '',
            }
          : {
              id: data?.id,
              masId: data?.masId,
              onboardingChannel: getOnboardingChannel(data?.id),
              type: data?.type,
              level: data?.level,
              group: data?.group?.brandName,
              subGroup: data?.subGroup?.brandName,
            },
      )
      if (searchFilterBy === 'SubGroup ID') {
        setStatus(getLovsDescriptionFromKeyValue('Status', data?.[0]?.status)?.toString()?.toLowerCase())
      } else {
        setStatus(getLovsDescriptionFromKeyValue('Status', data?.status)?.toString()?.toLowerCase())
      }
    },
    [searchFilterBy],
  )

  useEffect(() => {
    const searchDataList = searchData(EmType.Search)
    if (searchFilterBy === 'Group ID') {
      onSearchRowPress(group)
      setSearchListData([])
      if (globalSearchString === '') {
        setShowSearchScreen(false)
      } else {
        setShowSearchScreen(true)
      }
    } else if (searchFilterBy === 'SubGroup ID') {
      onSearchRowPress(subgroup)
      setSearchListData([])
      if (globalSearchString === '') {
        setShowSearchScreen(false)
      } else {
        setShowSearchScreen(true)
      }
    } else {
      if (
        searchDataList?.length > 1 &&
        from !== 'CHECKER_MYQUEUE' &&
        from !== 'CHECKER_QUEUE' &&
        from !== 'MAKER_QUEUE'
      ) {
        console.log('search data: ', JSON.parse(JSON.stringify(searchDataList)))
        setShowSearchResults(true)
        setSearchListData(
          searchDataList.map((item) => {
            const { group, subGroup, ...rest } = item
            return rest
          }),
        )
        setSearchResultsCount(searchDataList.length)
      } else if (searchDataList?.length === 1) {
        if (from !== 'CHECKER_MYQUEUE' && from !== 'CHECKER_QUEUE' && from !== 'MAKER_QUEUE') {
          if (globalSearchString === '') {
            if (from === 'CREATE_ENTITY') {
              setShowSearchScreen(true)
              onSearchRowPress(searchDataList[0])
            } else {
              setShowSearchScreen(false)
            }
          } else {
            setShowSearchResults(true)
            onSearchRowPress(searchDataList[0])
          }
        }
      } else {
        if (from === 'search' || from === undefined) {
          if (globalSearchString === '') {
            setShowSearchScreen(false)
            if (searchDataList?.length === 0) {
              setSearchListData([])
              setSearchResultsCount(0)
              if (previousFilterBy === '') {
                navigation.reset({
                  index: 0,
                  routes: [{ name: 'home' }],
                })
              }
            }
          }
        } else {
          setShowSearchScreen(true)
        }
      }
    }
    setPreviousFilterBy(searchFilterBy)
  }, [from, globalSearchString, group, navigation, onSearchRowPress, previousFilterBy, searchData, searchFilterBy])

  useEffect(() => {
    if (searchApiStatus === 'rejected') {
      setSearchListData([])
      setSearchResultsCount(0)
      setShowSearchScreen(false)
    } else if (searchApiStatus === 'pending') {
      setShowSearchScreen(false)
    } else {
      setShowSearchScreen(true)
    }
  }, [searchApiStatus])

  useEffect(() => {
    if (searchHandler?.state === 'fulfilled') {
      const searchDataList = searchData(EmType.Search)
      if (searchDataList?.length > 1) {
        console.log('search data: ', JSON.parse(JSON.stringify(searchDataList)))
        setShowSearchResults(true)
        setSearchListData(
          searchDataList.map((item) => {
            const { group, subGroup, ...rest } = item
            return rest
          }),
        )
        setSearchResultsCount(searchDataList?.length)
      }
      setIsLoading(false)
      setIsSyncing(false)
      rotateValue.setValue(0)
      rotateValue.stopAnimation()
    } else if (searchHandler?.state === 'rejected') {
      setIsLoading(false)
      setIsSyncing(false)
      rotateValue.setValue(0)
      rotateValue.stopAnimation()
    }
  }, [rotateValue, searchData, searchHandler.state])

  useEffect(() => {
    if (fetchSyncWithMasHandler?.state === 'fulfilled' || fetchSyncWithMasHandler?.state === 'rejected') {
      if (fetchSyncWithMasHandler?.state === 'fulfilled') {
        const date = new Date()
        setLastSyncedDate(`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`)
        searchApi(globalSearchString, searchFilterBy, 'ALL')
      }
    }
  }, [fetchSyncWithMasHandler.state, globalSearchString, rotateValue, searchApi, searchFilterBy])

  const getKeyTitle = (key: string, type: string, entStatus: string) => {
    const obj = {
      id:
        type === 'Entity ID'
          ? (from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE') &&
            entStatus !== 'Completed'
            ? 'Application ID: '
            : 'Entity ID: '
          : type === 'Group ID'
          ? 'Group ID: '
          : type === 'SubGroup ID'
          ? 'Sub Group ID: '
          : from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
          ? 'Application ID: '
          : '',
      masId: 'Parent Id: ',
      onboardingChannel: 'Onboarding Channel: ',
      type: 'Type: ',
      level: ' Level: ',
      group: 'Group: ',
      subGroup: 'Sub-Group: ',
    }
    return obj[key]
  }

  const onContactProfChange = (index: number, key: string, value: string) => {
    if (searchFilterBy !== 'Group ID' && searchFilterBy !== 'SubGroup ID') {
      if (!isMasEntity) {
        updateContactProfilesFromSearch(selectedEntity?.id, index, key, value)
      }
    } else if (selectedEntity?.identificationNumber) {
      updateContactOfGroupSubGroup(selectedEntity?.identificationNumber, index, key, value)
    }
  }

  const isContactProfileValid = () => {}
  const isDocumentationValid = () => {}

  console.log('selectedEntity', selectedEntity)

  const getScreen: any =
    from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
      ? {
          1: <AccountSummary selectedEntity={selectedEntity} />,
          2: <EntityHierarchy selectedEntity={selectedEntity} type={EmType.applicationQueue} />,
          3: <TIDList selectedEntity={selectedEntity} type={EmType.applicationQueue} />,
          4: <EmsDevices selectedEntity={selectedEntity} type={EmType.applicationQueue} />,
          5: <AuditTrail data={[]} />, //<TransactionReport />,
          6: (
            <BusinessDetails
              type={EmType.applicationQueue}
              isLinkToMAS={false}
              selectedEntity={selectedEntity}
              isMasEntity={isMasEntity}
              showAllFields={true}
            />
          ),
          7: (
            <ContactProfiles
              type={EmType.applicationQueue}
              isEditMode={false}
              onDataChange={onContactProfChange}
              isValidToProceed={isContactProfileValid}
              selectedEntity={selectedEntity}
              isLinkToMAS={false}
            />
          ),
          8: <SettlementDetails type={EmType.applicationQueue} selectedEntity={selectedEntity} isLinkToMAS={true} />,
          9: (
            <Documentation
              type={
                from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
                  ? EmType.applicationQueue
                  : EmType.Search
              }
              isValidToProceed={isDocumentationValid}
              selectedEntity={selectedEntity}
            />
          ),
        }
      : {
          1: <AccountSummary selectedEntity={selectedEntity} />,
          2: <EntityHierarchy selectedEntity={selectedEntity} type={EmType.Search} />,
          3: <TIDList selectedEntity={selectedEntity} type={EmType.Search} />,
          4: <EmsDevices selectedEntity={selectedEntity} type={EmType.Search} />,
          5: <AuditTrail data={[]} />, //<TransactionReport />,
          6: (
            <BusinessDetails
              type={EmType.Search}
              isLinkToMAS={false}
              selectedEntity={selectedEntity}
              isMasEntity={isMasEntity}
              showAllFields={true}
            />
          ),
          7: (
            <ContactProfiles
              type={EmType.Search}
              isEditMode={false}
              onDataChange={onContactProfChange}
              isValidToProceed={isContactProfileValid}
              selectedEntity={selectedEntity}
              isLinkToMAS={false}
            />
          ),
          8: <SettlementDetails type={EmType.Search} selectedEntity={selectedEntity} isLinkToMAS={true} />,
          9: (
            <Documentation
              type={
                from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
                  ? EmType.applicationQueue
                  : EmType.Search
              }
              isValidToProceed={isDocumentationValid}
              selectedEntity={selectedEntity}
            />
          ),
          10: <Settings type={EmType.Search} selectedEntity={selectedEntity} />,
        }

  const fetchDataOnPageChange = () => {
    console.count('===> OnPageChange')
    searchApi(globalSearchString, searchFilterBy, 'ALL')
    setIsLoading(true)
  }

  const onFilterPress = () => {
    setFilterVisible(false)
  }

  const applyFilter = () => {
    setFilterVisible(false)
    setFilterApplied(true)
    const data = searchDataWithFilters()
    setSearchListData(data)
  }

  const restoreDefaults = () => {
    setFilterApplied(false)
  }

  const getIsSubMenuExpanded = (isExpanded: boolean) => {
    setIsSubMenuExpanded(isExpanded)
  }

  const onApproveReject = (value: string, comments: string) => {
    setCheckerApproved(value === 'Approved')
    fetchApproveRejectTask(data?.applicationId, value, comments)
  }

  const onNavigateToMyqueue = () => {
    setCheckerApproved(false)
    navigation.reset({
      index: 0,
      routes: [{ name: 'checkerMyQueue' }],
    })
    setSideMenuRefresh(true)
  }
  const screenHeight = useWindowDimensions()?.height
  console.log('screenHeight', screenHeight)
  return (
    <>
      <ModBox
        show={!showCheckerStatus && showSearchScreen}
        {...styles.container}
        minHeight={
          from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
            ? '103%'
            : isSubMenuExpanded
            ? screenHeight > 600
              ? '100%'
              : '157%'
            : screenHeight > 600
            ? '100%'
            : '104%'
        }>
        <Header
          show={!showSearchResults}
          rotateValue={rotateValue}
          isSyncing={isSyncing}
          selectedEntity={selectedEntity}
          getSyncWithMasData={getSyncWithMasData}
          fetchSyncWithMas={fetchSyncWithMas}
          setIsSyncing={setIsSyncing}
          from={from}
          searchData={searchData}
          navigation={navigation}
          setShowSearchResults={setShowSearchResults}
          searchItemPressed={searchItemPressed}
          searchFilterBy={searchFilterBy}
          group={group}
          data={data}
          showSearchResults={showSearchResults}
          isMasEntity={isMasEntity}
          headerData={headerData}
          getKeyTitle={getKeyTitle}
          lastSyncedDate={lastSyncedDate}
          status={status}
          showApproveReject={showApproveReject}
          setSideMenuRefresh={setSideMenuRefresh}
          accessConfig={accessConfig}
          getLovsDescriptionFromKeyValue={getLovsDescriptionFromKeyValue}
          subgroup={subgroup}
        />
        <ModBox show={showSearchResults} marginLeft={16} marginTop={24}>
          <Text
            title={`${searchResultsCount} Search result for "${globalSearchString}" found`}
            color={'BLACK_21'}
            fontSize={18}
            fontFamily={'jiotype-bold'}
          />
        </ModBox>
        <ModBox show={!showSearchResults} h={'100%'}>
          <ModBox show={searchItemPressed} flexDirection={'row'} h={'100%'}>
            <Box w={220} borderRightWidth={1} borderRightColor={'BORDER_COLOR'} h={'100%'}>
              <Menu
                selectedScreen={setSelectedScreenId}
                from={from}
                selectedEntity={selectedEntity}
                getSubMenuExpanded={getIsSubMenuExpanded}
                selectedScreenId={selectedScreenId}
              />
            </Box>
            <Box flexGrow={1} flex={1} w={'100%'} h={'100%'}>
              {getScreen[selectedScreenId]}
            </Box>
          </ModBox>
        </ModBox>
        <ModBox
          direction="row"
          justifyContent={'flex-end'}
          show={searchListData?.length > 0 && showSearchResults}
          marginRight={16}>
          <ActionsMenu
            fetchDataOnChange={fetchDataOnPageChange}
            filterVisible={filterVisible}
            setFilterVisible={setFilterVisible}
            showSearch={false}
            enableFilter={false}
            showCalendar={false}
            filterApplied={filterApplied}
            defaultPage={1}
          />
        </ModBox>
        <ModBox show={isLoading}>
          <LoaderNew type={'small'} color={'PRIMARY'} />
        </ModBox>
        <ModBox show={showSearchResults && !filterVisible && !isLoading} padding={16}>
          <SelectParentEntityList
            hide={false}
            title={''}
            data={searchListData}
            columnFlexMapper={searchColumnSize}
            headerTitles={searchHeaderTitle}
            onItemPress={onSearchRowPress}
          />
        </ModBox>
        <ModBox show={filterVisible && showSearchResults}>
          <Filters
            onPress={onFilterPress}
            selectedFilteredData={selectedFilteredData}
            updateFilters={updateFilters}
            filterData={[levelFilterData, statusFilterData]}
            checkSelected={checkSelected}
            apply={applyFilter}
            selectedValue={[selectedFilteredData?.levelSelected, selectedFilteredData?.statusSelected]}
            mode={filterTypes.search}
            restoreDefaults={restoreDefaults}
          />
        </ModBox>
        <ModBox backgroundColor={'WHITE'} show={showApproveReject} position={'sticky'} bottom={0}>
          <Footer
            show={
              from !== undefined || from === 'CHECKER_MYQUEUE' || from === 'CHECKER_QUEUE' || from === 'MAKER_QUEUE'
            }
            onSubmit={onApproveReject}
            applicationStatus={data?.applicationStatus}
            checkerComments={data?.comments}
          />
        </ModBox>
      </ModBox>
      <ModBox show={showCheckerStatus}>
        <CheckerStatus isCheckerApproved={isCheckerApproved} data={approveRejectData} onSubmit={onNavigateToMyqueue} />
      </ModBox>
    </>
  )
}
export default SearchEntity
